module.exports = __webpack_public_path__ + "assets/img/ser_119025.c90135ed.png";